var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeAutoObservable, runInAction } from 'mobx';
import _ from 'lodash';
import { definitionsService } from 'ziphy-web-shared/basic/api';
export class DefinitionsStore {
    constructor() {
        this.layouts = new LayoutsStore();
        this.macros = new MacrosStore();
        this.selects = new SelectsStore();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                // this.layouts.load(),
                this.macros.load(),
                this.selects.load(),
                //
            ]);
        });
    }
}
/*
 * Layouts Store
 */
class LayoutsStore {
    constructor() {
        this.storage = [];
        makeAutoObservable(this);
    }
    get items() {
        return this.storage;
    }
    // Actions
    load(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield definitionsService.layouts.list(params, Object.assign({ cacheTime: 3600 }, options));
            if (!response.error && !response.isFromCache) {
                runInAction(() => { var _a; return (this.storage = (_a = response.prepared) === null || _a === void 0 ? void 0 : _a.items); });
            }
            return response;
        });
    }
}
/*
 * Macros Store
 */
class MacrosStore {
    constructor() {
        this.storage = [];
        makeAutoObservable(this);
    }
    get items() {
        return _.keyBy(this.storage, 'id');
    }
    get aliasesMap() {
        let map = {};
        this.storage.forEach((macro) => {
            var _a;
            map[macro.id] = macro.id;
            (_a = macro.aliases) === null || _a === void 0 ? void 0 : _a.forEach((x) => (map[x] = macro.id));
        });
        return map;
    }
    get groupedBySection() {
        const itemsWithAllowed = this.storage.flatMap((item) => item.allowed.map((allowedKey) => (Object.assign(Object.assign({}, item), { allowedKey }))));
        const groupedByAllowed = _.groupBy(_.orderBy(itemsWithAllowed, ['name'], ['asc']), 'allowedKey');
        return _.mapValues(groupedByAllowed, (group) => {
            return _.groupBy(group, (value) => {
                return value.type === 'resources' ? 'resource' : value.type;
            });
        });
    }
    hasSectionMacros(sectionId) {
        return !_.isEmpty(this.groupedBySection[sectionId]);
    }
    // Actions
    load(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield definitionsService.macros.list(params, Object.assign({ cacheTime: 3600 }, options));
            if (!response.error && !response.isFromCache) {
                runInAction(() => { var _a; return (this.storage = (_a = response.prepared) === null || _a === void 0 ? void 0 : _a.items); });
            }
            return response;
        });
    }
}
/*
 * Selects Store
 */
class SelectsStore {
    constructor() {
        this.storage = {};
        makeAutoObservable(this);
    }
    get items() {
        return this.storage;
    }
    get values() {
        const result = {};
        Object.entries(this.storage).forEach(([selectId, select]) => {
            select.values.forEach((value) => {
                result[[selectId, value.code].join('_')] = value;
            });
        });
        return result;
    }
    valuesMap(id) {
        var _a;
        const result = {};
        (_a = this.storage[id]) === null || _a === void 0 ? void 0 : _a.values.forEach((value) => (result[value.code] = value));
        return result;
    }
    getValue(selectId, code) {
        return this.values[[selectId, code].join('_')];
    }
    // Actions
    load(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield definitionsService.selects.list(params, Object.assign({ cacheTime: 3600 }, options));
            if (!response.error && !response.isFromCache) {
                runInAction(() => {
                    var _a;
                    (_a = response.prepared) === null || _a === void 0 ? void 0 : _a.items.forEach((x) => {
                        this.storage[x.id] = Object.assign(Object.assign({}, x), { values: x.values.map((v) => (Object.assign(Object.assign({}, v), { selectId: x.id }))) });
                    });
                });
            }
            return response;
        });
    }
}
export const $definitions = new DefinitionsStore();
